import {DatevWizardGetFirmaState} from './datev-wizard-get-firma.state';


export const datevWizardGetFirmaStateInitial: DatevWizardGetFirmaState = {
  firmenId: undefined,
  invalidFirmenIds: [],
  firmenUsedInThePast: [],
  selectedIdentifierType: 'betriebsnummer',
  searchResults: undefined,
  isSearching: false,
  searchError: undefined,
};
